import RegistrationFinep from ".";
import { CompanyContextFinepProvider } from "../../../Contexts/CompanyFinepContext";
import { RegistrationDocumentsFinepProvider } from "../../../Contexts/RegistrationDocumentsFinepContext";
import { TechnologicalFeaturesFinepProvider } from "../../../Contexts/TechnologicalFeaturesFinepContext";

const TabRegisterFinepContextChildren = () => {
    return (
        <CompanyContextFinepProvider>
            <TechnologicalFeaturesFinepProvider>
                <RegistrationDocumentsFinepProvider>
                    <RegistrationFinep />
                </RegistrationDocumentsFinepProvider>
            </TechnologicalFeaturesFinepProvider>
        </CompanyContextFinepProvider>
    );
}

export default TabRegisterFinepContextChildren;